import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import styled from 'styled-components';
import { SketchPicker } from 'react-color';
import tinycolor from 'tinycolor2';
import * as colors from 'constants/colors';
import theme from 'config/theme';
import { changeColor } from 'app/actions/schoolActions';
import { FormControl, FormLabel, Stack, TextField } from '@mui/material';

const ColorFieldWrapper = styled.div`
	display: flex;
	align-items: center;
`;

const Swatch = styled.div`
	min-width: 5rem;
	height: 3.7rem;
	border: 0.1rem solid ${(props) => props.theme.mercury};
`;

const Color = styled.div`
	width: 100%;
	height: 100%;
	background-color: ${(props) => props.color};
`;

const Picker = styled(SketchPicker)`
	position: absolute !important;
	left: 3rem;
	top: 6.3rem;
	box-shadow: 0rem 0rem 1rem 0 rgba(0, 0, 0, 0.3) !important;
	z-index: 10;
`;

const Cover = styled.div`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;

const Warning = styled.div`
	color: ${theme.overdue};
`;

// TODO: replace with mui-color-input the same as in Agencies when Webpack is upgraded to v5
export const ColorPickerField = ({ disabled }) => {
	const dispatch = useAppDispatch();
	const schoolColor = useAppSelector((state) => state.school.color);
	const [showSchoolColorPicker, setShowSchoolColorPicker] = useState(false);
	const [color, setColor] = useState(schoolColor);

	useEffect(() => {
		setColor(schoolColor);
	}, [schoolColor]);

	const handleToggleSchoolColorPicker = () => {
		setShowSchoolColorPicker(!showSchoolColorPicker);
	};

	const handlePickerClose = () => {
		setShowSchoolColorPicker(false);
	};

	const handleBlur = () => {
		const newColor = tinycolor(color);

		setShowSchoolColorPicker(false);

		if (newColor.isValid()) {
			setColor(newColor.toHexString());
			dispatch(changeColor(newColor.toHexString()));
		}
	};

	const handleChangeField = (value) => {
		setColor(value);
	};

	const handleChangeColor = (newColor) => {
		setColor(newColor.hex);

		dispatch(changeColor(newColor.hex));
	};

	const preset = colors.COLOR_GREY.concat(
		colors.COLOR_RED,
		colors.COLOR_GREEN,
		colors.COLOR_BLUE,
	);

	return (
		<div>
			<h4>Colour</h4>
			<ColorFieldWrapper>
				<Stack direction="row" alignItems="flex-end">
					<FormControl>
						<FormLabel id="color-picker-label">Hex code</FormLabel>
						<TextField
							size="small"
							aria-labelledby="color-picker-label"
							inputProps={{ maxLength: 7 }}
							disabled={disabled}
							value={color}
							name="color"
							onBlur={handleBlur}
							onChange={(event) => handleChangeField(event.target.value)}
						/>
					</FormControl>
					<Swatch
						onClick={() => {
							if (disabled) {
								return false;
							}

							handleToggleSchoolColorPicker();
						}}
					>
						<Color color={schoolColor} />
					</Swatch>
					{showSchoolColorPicker && (
						<>
							<Cover onClick={handlePickerClose} />
							<Picker
								color={schoolColor}
								presetColors={preset}
								onChangeComplete={handleChangeColor}
							/>
						</>
					)}
				</Stack>
				{!tinycolor.isReadable(schoolColor, '#ffffff') && (
					<Warning>
						Warning: this colour may reduce text readability, please consider a
						darker colour.
					</Warning>
				)}
			</ColorFieldWrapper>
		</div>
	);
};
